import type { TourConfig } from "./types";

export const settingsTour: TourConfig = {
    id: "settings",
    name: "Settings Tour",
    description: "Learn how to customize documents and connect your PIMS",
    showInHelpMenu: true,
    steps: [
        {
            placement: "center",
            scoutState: "wave",
            title: "Customize Your Documents",
            content:
                "HappyDoc generates documents based on templates you control. Let me show you how to make them match your workflow.",
        },
        {
            target: '[data-tour="add-doctor"]',
            placement: "bottom",
            scoutState: "point",
            title: "Add Your Doctors",
            content:
                "Add each doctor and tech who will use HappyDoc. Documents are generated per-doctor, so we need to know who's who.",
            // The doctors roster moved from General to its own Schedule tab (EN-1056). waitForTarget
            // resolves on element presence, so pointing this at ?tab=general would wait on a target
            // that never mounts.
            route: "/settings?tab=schedule",
            waitForTarget: true,
        },
        {
            target: "#tab-documents",
            placement: "right",
            scoutState: "point",
            title: "Your Document Types",
            content: "This is where your templates live — SOAP notes, discharge summaries, client emails.",
            // Stays on the previous step's tab: the rail renders on every tab, so #tab-documents is
            // already present and routing back to General would be a pointless extra navigation.
            route: "/settings?tab=schedule",
            spotlightClicks: true,
            waitForTarget: true,
            actionLabel: "Click the Documents tab to continue",
        },
        {
            target: '[data-tour="document-type-list"]',
            placement: "right",
            scoutState: "point",
            title: "Your Templates",
            content:
                "Each card is a document type. You can clone the defaults and customize them, or create new ones from scratch. There's no limit.",
            route: "/settings?tab=documents",
            waitForTarget: true,
        },
        {
            target: '[data-tour="document-builder"]',
            placement: "bottom",
            scoutState: "point",
            title: "The Document Builder",
            content:
                "Open any template to customize it. Drag and drop fields, add custom instructions, set default values for normal findings.",
            route: "/settings?tab=documents",
            waitForTarget: true,
        },
        {
            target: "#tab-integrations",
            placement: "right",
            scoutState: "point",
            title: "Connect Your PIMS",
            content:
                "Set up your integration here so finished documents write back to your practice management system automatically. No more copy-paste.",
            route: "/settings?tab=integrations",
            waitForTarget: true,
        },
        {
            placement: "center",
            scoutState: "celebrate",
            title: "You're Set",
            content:
                "Your documents will generate based on these templates. Come back and tweak them anytime — you can't break anything.",
        },
    ],
};
